// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "library-swiper-css" + "." + "4e6224c99437343ab84a" + ".css";
};